const previewVizMessage =
    '⚠️ This is a preview of a new visualization component. Minor updates and bug fixes should be expected.';

export default previewVizMessage;
